import { FieldValue, RuleProps } from 'types/application';

export const SECT_PE_ON_GOING = 'pe-details';

export const EVENT_PE_FIELDS = [
    {
        sectionID: SECT_PE_ON_GOING,
        sectionName: '',
        fieldList: [
            {
                id: 'event-title',
                apiID: 'Title',
                label: 'Event Title',
                type: 'longText',
                rule: {
                    disabled: true,
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (currentValue) {
                            const result = /(\b((https?|ftp|file):\/\/|(www\.))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig.test(
                                currentValue as string
                            );
                            if (result) return 'URL Not Allowed in Title.';
                        }

                        return true;
                    }
                },
                span: 12
            },
            {
                id: 'event-date-time',
                label: 'Event Date & Time',
                type: 'table',
                rule: { disabled: true },
                labelNote: 'Event Start Date must not be less than 7 days from application date.',
                subFields: [
                    {
                        id: 'from',
                        header: 'From',
                        type: 'dateTime',
                        rule: { disabled: true }
                    },
                    {
                        id: 'to',
                        header: 'To',
                        type: 'dateTime',
                        rule: { disabled: true }
                    }
                ],
                span: 12,
                buttonTitle: 'Add Date & Time'
            },
            {
                id: 'pe-no',
                apiID: 'PELicenceNo',
                label: 'PE Licence No.',
                type: 'text',
                placeholder: 'Eg: L/PE/XXXXXX/YYYY',
                isNextEmpty: true,
                labelNote: 'Please include /P at the end of the PE Licence No., if applicable.',
                rule: { required: true, pattern: /^L\/PE\/[0-9]{6}\/[0-9]{4}(\/P)?$/ }
            },
            {
                id: 'pe-start',
                apiID: 'PELicenceStartDate',
                label: 'PE Licence Start Date',
                type: 'date',
                rule: {
                    baseIds: [`${SECT_PE_ON_GOING}-event-date-time`],
                    required: true,
                    dateLimit: ({ baseValues }: RuleProps) => {
                        const base = baseValues && (baseValues[`${SECT_PE_ON_GOING}-event-date-time`] as { [key: string]: FieldValue }[]);
                        const baseFrom = base?.map((values: { [key: string]: FieldValue }) => new Date(values.from as string).getTime());
                        const minDateFrom = baseFrom && new Date(Math.min(...baseFrom));
                        const baseDate = minDateFrom || new Date();
                        return { maxDate: baseDate };
                    }
                }
            },
            {
                id: 'pe-end',
                apiID: 'PELicenceEndDate',
                label: 'PE Licence End Date',
                type: 'date',
                // rule: [
                //     {
                //         required: true
                //     },
                //     {
                //         baseField: `${SECT_PE_ON_GOING}-pe-start`,
                //         dateLimit: { minDay: 0 },
                //         setValue: () => ''
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PE_ON_GOING}-event-date-time`],
                    required: true,
                    dateLimit: ({ baseValues }: RuleProps) => {
                        const base = baseValues && (baseValues[`${SECT_PE_ON_GOING}-event-date-time`] as { [key: string]: FieldValue }[]);
                        const baseTo = base?.map((values: { [key: string]: FieldValue }) => new Date(values.to as string).getTime());
                        const maxDateTo = baseTo && new Date(Math.max(...baseTo));
                        const baseDate = maxDateTo || new Date();
                        return { minDate: baseDate };
                    }
                }
            }
        ]
    }
];
